module.exports = __webpack_public_path__ + "static/magicTheGatheringGif-5cec57ac5bdfe572fc96073dea815fdc.gif";